import { Button, Checkbox, Popover } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { Accordion } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { FETCH_ADMIN_DASHBOARD_REPORT, FETCH_ADMIN_DETAILED_REPORT, FETCH_CONSOLIDATED_REPORTS } from "../../actions/InterbranchAdminActions";
import ConsolidatedReport from "../../components/ConsolidatedReport/ConsolidatedReport";
import CustomeModal from "../../components/CustomeModal/CustomeModal";
import AllAppointments from "../../components/InterbranchAdminComponents/AllAppointments/AllAppointments";

import BoookAppointment from "../../components/InterbranchAdminComponents/BookAppointment/BoookAppointment";
import InterbranchAdmindashboard from "../../components/InterbranchAdminComponents/Dashboard/InterbranchAdmindashboard";
import RequestedAppointments from "../../components/InterbranchAdminComponents/RequestedAppointments/RequestedAppointments";
import Users from "../../components/InterbranchAdminComponents/Users/Users";
import Misreport from "../../components/MisReport/Misreport";
import { logoutAction } from "../../actions/LoginAction";
import MisReportModalContent from "../../components/MisReportModal/MisReportModalContent";

import TodaysReport from "../../components/TodaysReport/TodaysReport";
import TodaysReportModalContent from "../../components/TodaysReportModalContent/TodaysReportModalContent";
import RequestModalContent from "../../components/RequestModalContent/RequestModalContent";

import { SuperAdminSideMenu } from "./constants";
import "./interbranchadminhome.css";
import BookingProgressConformModal from "../../components/InterbranchAdminComponents/Modal/BookingProgressConformModal/BookingProgressConformModal";
import ManageDepartmentProfile from "../../components/ManageDepartmentProfile/ManageDepartmentProfile";
import Sms from "../../components/InterbranchAdminComponents/Communication/Sms/Sms";
import { DepartmentProfileNavIcon } from "../../assets/NavbarIcons/NavIcons";
import { Assets } from "../../assets/Assets";
import logoAssets from "../../components/Layout/Assets";
import { AssetStore } from "../../assets/AssetsStore";
import logout from "../../assets/logout_FILL0_wght400_GRAD0_opsz48.svg";
import ManageHealthProviders from "../../components/ManageHealthProviders/Index";
import Patient from "../../components/InterbranchAdminComponents/Users/Patient";
import Payments from "../../components/InterbranchAdminComponents/Payments/payments";
import DepartmentManagement from "../../components/DepartmentManagement/DepartmentManagement";
import SpecialityManagement from "../../components/DepartmentManagement/SpecialityManagement";

export const InterbranchContext = React.createContext({});
export const InterbranchCopntextProvider = InterbranchContext.Provider;

function InterbranchAdminHome() {
	//States....................................................................................
	let [activeLeft, setActiveleft] = useState("Home");
	let [headerLeftTitle, setHeaderLeftTitle] = useState("Home - Overview");
	let [netxTarget, setNextTarget] = useState();
	let [bookingFormSwitchModal, setBookingFormSwitchModal] = useState(false);
	const [expandedAccordion, setExpandedAccordion] = useState([0]);
	let [selectedDashboardComponents, setSelectedDashboardComponents] = useState([
		{ name: "Daily Consultation", status: true },
		{ name: "Traffic split by platform", status: true },
		{ name: "Top 5 Doctors", status: true },
		{ name: "Top 5 Specialities", status: true },
		{ name: "Total Patients", status: true },
		{ name: "Patient Location split", status: true },
		{ name: "Appointment Status", status: true },
		{ name: "Appointment Requests", status: true },
		{ name: "Daily Appointments", status: true },
	]);

	const [interbranchData, setInterbranchdata] = useState({
		bookingForm: {
			modeOfConsultation: "Video",
		},
	});

	//Declerations..............................................................................
	let dispatch = useDispatch();
	const history = useHistory();
	const userData = useSelector((state) => state.login.user);
	const userDetails = JSON.parse(localStorage.getItem("userData"));
	const [IslogedIn, setIslogedIn] = useState(JSON.parse(localStorage.getItem("userData")) != undefined ? true : false);

	let dashboardItemsList = [
		"Daily Consultation",
		"Traffic split by platform",
		"Top 5 Doctors",
		"Top 5 Specialities",
		"New vs Existing Patients",
		"Patient Location",
		"Appointment Status",
		"Appointment Requests",
		"Daily Appointments",
		"Patient Gender",
		"Patient Age",
		"Type of Appointment",
		"Request Elapsed time",
		"In Progress Reason",
		"Rejected List",
	];

	const content = (
		<>
			{dashboardItemsList.map((eachItem, key) => {
				let index = selectedDashboardComponents.findIndex((e) => e.name == eachItem);
				return (
					<p key={key}>
						<Checkbox
							checked={selectedDashboardComponents[index]?.status}
							value={selectedDashboardComponents[index]?.status}
							onChange={(e) => {
								onClickSelectItemCheckbox(eachItem, e);
							}}
						>
							{eachItem}
						</Checkbox>
					</p>
				);
			})}
		</>
	);

	const { todaysReportModal, misReportModal, requestmodal } = useSelector((state) => state.interbranchModal);

	useEffect(() => {
		if (IslogedIn) {
			console.log("procees");
		} else {
			history.push("/signin");
		}
	});

	//Refs......................................................................................
	const ref = useRef(null);

	//Functions................................................................................
	const getActiveComponent = (name) => {
		switch (name) {
			case SuperAdminSideMenu[0].options[0].name:
				return <InterbranchAdmindashboard setActiveleft={setActiveleft} selectedDashboardComponents={selectedDashboardComponents} dashboardItemsList={dashboardItemsList} setExpandedAccordion={setExpandedAccordion} setHeaderLeftTitle={setHeaderLeftTitle} />;

			case SuperAdminSideMenu[1].options[0].name:
				return <TodaysReport />;
			case SuperAdminSideMenu[1].options[1].name:
				return <BoookAppointment />;
			case SuperAdminSideMenu[1].options[2].name:
				return <RequestedAppointments />;

			// case interbranchAdminSideMenu[1].options[0].name:
			//   return <Users isDoctor={true} />;
			case SuperAdminSideMenu[2].options[0]?.name:
				return <Patient isDoctor={false} />;

			case SuperAdminSideMenu[3].options[0].name:
				return <DepartmentManagement />;
			case SuperAdminSideMenu[3].options[1].name:
				return <SpecialityManagement />;

			case SuperAdminSideMenu[4].options[0].name:
				return <Misreport />;
			case SuperAdminSideMenu[5].options[0].name:
				return <Payments />;

			// case interbranchAdminSideMenu[1].options[1].name:
			//    return <ConsolidatedReport />;

			// case interbranchAdminSideMenu[2].options[0].name:
			//   return <ManageHealthProviders />;
			default:
				return null;

			// case interbranchAdminSideMenu[0].options[4].menuItems[0]?.name:
			//   return <Users isDoctor={true} />;
			// case interbranchAdminSideMenu[0].options[4].menuItems[1]?.name:
			//   return <Users isDoctor={false} />;
			// case interbranchAdminSideMenu[0].options[5].menuItems[0]?.name:
			//   return <ManageDepartmentProfile isDoctor={true} />;
			// case interbranchAdminSideMenu[0].options[5].menuItems[1]?.name:
			//   return null;
			// case interbranchAdminSideMenu[0].options[6].menuItems[0]?.name:
			//   return <Sms />;
		}
	};
	function onClickSelectItemCheckbox(name, e) {
		let { checked } = e?.target;
		var items = [...selectedDashboardComponents];
		var foundIndex = items.findIndex((x) => x.name == name);
		items[foundIndex].status = checked;
		setSelectedDashboardComponents(items);

		// setSelectedDashboardComponents((prev)=>[...prev,{name, status:checked}])
	}
	useEffect(() => {
		dispatch(FETCH_ADMIN_DASHBOARD_REPORT());
		// dispatch(FETCH_ADMIN_DETAILED_REPORT());
		//  dispatch(FETCH_CONSOLIDATED_REPORTS());
	}, []);
	const handleNavItemClick = (target, title) => {
			setHeaderLeftTitle(title || target);
			if (checkIfBookingFormInProgress()) {
				setBookingFormSwitchModal(true);
				setNextTarget(target);
			} else {
				setActiveleft(target);
				// Determine which accordion section contains this target and expand it
				const accordionIndex = SuperAdminSideMenu.findIndex((section) => section.options.some((option) => option.name === target));
				if (accordionIndex !== -1) {
					setExpandedAccordion([accordionIndex]);
				}
			}
		};
	const checkIfBookingFormInProgress = () => {
		let bookingForm = interbranchData?.bookingForm;
		console.log(bookingForm);
		return bookingForm && (bookingForm.patientNumber || bookingForm.email || bookingForm.patientName || bookingForm.dob || bookingForm.gender);
	};
	const handleOkBookingTabSwitch = () => {
		let form = interbranchData?.bookingFormRef;
		console.log("form1", interbranchData?.bookingFormRef);

		if (form) {
			form.resetFields();
			setInterbranchdata({
				...interbranchData,
				bookingForm: {},
			});
			setBookingFormSwitchModal(false);
			setActiveleft(netxTarget);
		}
	};
	const handleCancelBookingTabSwitch = () => {
		setBookingFormSwitchModal(false);
	};
	const getPageHeaderRightTitle = () => {
		switch (activeLeft) {
			case "Home":
				return (
					<Popover content={content} title="Select item(s) to show" trigger="click" placement="rightBottom">
						<Button className="caption">
							<i class="fal fa-cog"></i>
						</Button>
					</Popover>
				);

			case "SMS":
				return <span className="dashboard-top-right-title">Last updated 13:00am on 15,may,2020</span>;

			default:
				return null;
		}
	};

	function handleLogout() {
		dispatch(logoutAction(userData, history)).then((res) => {
			if (res) {
				history.push("/signin");
			}
		});
	}
	console.log("userId", userDetails?.userId);

	function isOptionVisibleForUser(option) {
		if (option.blockedForIDs && option.blockedForIDs.includes(userDetails?.userId)) {
			return false; // Hide the option if the user's ID is in the blocked list
		}
		return true; // Show the option otherwise
	}
	// Iterate through the menu options and filter out the ones that should be visible
	const visibleMenuOptions = SuperAdminSideMenu.map((section) => ({
		tittle: section.tittle,
		options: section.options.filter((option) => isOptionVisibleForUser(option)),
	}));

	console.log("visibleMenuOptions", visibleMenuOptions);

	return (
		<InterbranchCopntextProvider value={{ interbranchData, setInterbranchdata }}>
			<div className="interbranch-admin-container">
				<div className="left-container">
					<div className="letf-top">
						<div className="w-100 d-flex flex-row align-items-center justify-content-center">
							<img className="nav-branding" src={logoAssets.gangalogo} alt="" />
						</div>

						<Accordion activeKey={expandedAccordion} className="side_nav_accordion_interbranch" onSelect={(keys) => setExpandedAccordion(keys)}>
							{visibleMenuOptions.map((object, menuKey) => {
								if (object?.tittle) {
									console.log(object.tittle, menuKey);
									return (
										<Accordion.Item key={menuKey} eventKey={menuKey}>
											<Accordion.Header>
												<div className="list-tittle">{object.tittle}</div>
											</Accordion.Header>

											{object.options.map((element, optionKey) => {
												if (element.name === "Book Appointment" && userDetails?.userId === "48810986") {
												} else {
													return (
														<Accordion.Body
															onClick={() => {
																handleNavItemClick(element?.name);
															}}
															className={activeLeft == element?.name && "active-nav-item-interbranch"}
															key={optionKey}
														>
															<div className="icon">{element.ico}</div>
															<div className="text">{element.name}</div>
														</Accordion.Body>
													);
												}
											})}
										</Accordion.Item>
									);
								} else {
									return (
										<>
											{object.options.map((element, optionKey) => {
												return (
													<button
														key={`selarated_${optionKey}`}
														onClick={() => {
															handleNavItemClick(element?.name);
														}}
														className={`${activeLeft == element?.name && "active-nav-item-interbranch"} separated-nav-button`}
													>
														<div className="icon">{element.ico}</div>
														<div className="text">{element?.name}</div>
													</button>
												);
											})}
										</>
									);
								}
							})}
						</Accordion>
					</div>

					<div className="header-card logout" onClick={handleLogout}>
						<div>
							<img src={logout} alt="Logout Icon" className="icon" />
						</div>
						SIGN OUT
					</div>
				</div>

				<div className="right-container" ref={ref}>
					<div className="header-card">
						<span className="dashboard-title">{headerLeftTitle}</span>
						{/* {getPageHeaderRightTitle()} */}
					</div>

					<div className="right-menu-container">
						<div className="container_interbranch">{getActiveComponent(activeLeft)}</div>
					</div>
				</div>

				<BookingProgressConformModal onOk={handleOkBookingTabSwitch} onCancel={handleCancelBookingTabSwitch} isModalOpen={bookingFormSwitchModal} />
			</div>
			{/* <CustomeModal
        width={700}
        state={todaysReportModal}
        modalName="todaysReportModal"
        component={<TodaysReportModalContent />}
        isRight
      /> */}

			<CustomeModal width={700} state={misReportModal} modalName="misReportModal" component={<MisReportModalContent />} isRight />
			{/* <CustomeModal
        width={700}
        state={requestmodal}
        modalName="requestmodal"
        component={<RequestModalContent />}
        isRight
      /> */}
		</InterbranchCopntextProvider>
	);
}

export default InterbranchAdminHome;
